module.exports = __webpack_public_path__ + "static/media/default.37ff5d5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/carInsurance/index/default.png
// module id = 1182
// module chunks = 0